import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Table,
  Card,
  Label,
  CardBody,
  CardHeader,
} from "reactstrap";
import Select from "react-select";
import NumberCommas from "../../Components/NumberCommas/NumberCommas";
import { formatDate } from "../../Components/FormatDate/FormatDate";
import LayoutWithBreadCrumb from "../../pages/Pages/Starter/LayoutWithBreadCrumb";
import BankServices from "../../Services/QRCodeServices/BankServices/BankServices";

const BankStatement = () => {
  const [banks, setBanks] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState("");
  const [bankData, setBankData] = useState({
    bankId: 0,
    bankName: "",
    currentBalance: 0,
    transactions: [],
  });

  const bankOptions = banks.map((bank) => ({
    value: bank.id,
    label: bank.name,
  }));

  const handleBankChange = (selectedOption) => {
    setSelectedBankId(selectedOption ? selectedOption.value : "");
  };

  async function fetchBankTransactions(id) {
    try {
      const response = await BankServices.getBankStatement(id);
      console.log("Bank statement data:", response);
      setBankData(response);
    } catch (error) {
      console.error("Error fetching bank statement:", error);
    }
  }

  useEffect(() => {
    async function fetchBanks() {
      try {
        const response = await BankServices.getList();
        console.log("Bank list:", response);
        setBanks(response);
      } catch (error) {
        console.error("Error fetching bank list:", error);
      }
    }

    fetchBanks();
  }, []);

  const handleReportClick = () => {
    fetchBankTransactions(selectedBankId);
  };

  return (
    <React.Fragment>
      <LayoutWithBreadCrumb
        title="Bank Statement Report"
        pageTitle="Bank Statement Report"
      >
        <Card>
          <CardBody>
            <Form>
              <Row className="mb-3">
                <Col sm={3}>
                  <Label>Bank Selection</Label>
                  <Select
                    value={bankOptions.find(
                      (option) => option.value === selectedBankId
                    )}
                    onChange={handleBankChange}
                    options={bankOptions}
                    isClearable
                  />
                </Col>
                <Col>
                  <Row className="justify-content-end me-2">
                    <Button 
                      onClick={handleReportClick} 
                      className="w-auto mt-4"
                      disabled={!selectedBankId}
                    >
                      Generate Report
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Form>

            <Row>
              {bankData.bankId > 0 && (
                <Card className="shadow-sm border-0">
                  <CardHeader className="py-3"></CardHeader>
                  <CardBody className="p-4">
                    <h5 className="mb-0 text-center font-weight-bold">
                      Bank Statement Information
                    </h5>
                    <Row className="mb-4">
                      <Col lg={6} className="mb-3 mb-lg-0">
                        <div className="d-flex mb-2">
                          <span className="font-weight-bold text-muted col-3">
                            Bank Name:
                          </span>
                          <span className="font-weight-bold col-9">
                            {bankData.bankName}
                          </span>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <Row className="mb-2">
                          <Col lg={10} className="text-end">
                            <span className="font-weight-bold text-muted">
                              Current Balance:
                            </span>
                          </Col>
                          <Col lg={2} className="text-end">
                            <span className="font-weight-bold d-flex justify-content-end gap-2 text-end">
                              Rs.
                              <NumberCommas number={bankData.currentBalance} />
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <div className="table-responsive">
                      <Table bordered hover className="mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th className="" style={{ width: "60px" }}>
                              S.N
                            </th>
                            <th className="" style={{ width: "180px" }}>
                              Transaction ID
                            </th>
                            <th className="" style={{ width: "130px" }}>
                              Date
                            </th>
                            <th className="">Remarks</th>
                            <th className="" style={{ width: "120px" }}>
                              Debit
                            </th>
                            <th className="" style={{ width: "120px" }}>
                              Credit
                            </th>
                            <th className="" style={{ width: "150px" }}>
                              Transaction By
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {bankData.transactions &&
                          bankData.transactions.length > 0 ? (
                            bankData.transactions.map((item, index) => (
                              <tr key={item.transactionId}>
                                <td className="">{index + 1}</td>
                                <td className="">{item.transactionId}</td>
                                <td className="">
                                  {formatDate(item.valueDate)}
                                </td>
                                <td className="">{item.remarks}</td>
                                <td className="">
                                  {item.transactionType === "Debit" ? (
                                    <NumberCommas number={item.amount} />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td className="">
                                  {item.transactionType === "Credit" ? (
                                    <NumberCommas number={item.amount} />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td className="">
                                  {item.transactionCreatedBy}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No transactions available.
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot className="font-weight-bold">
                          <tr>
                            <td colSpan="4" className="text-end">
                              Total
                            </td>
                            <td>
                              <NumberCommas
                                number={bankData.transactions
                                  .filter((t) => t.transactionType === "Debit")
                                  .reduce((sum, t) => sum + t.amount, 0)}
                              />
                            </td>
                            <td>
                              <NumberCommas
                                number={bankData.transactions
                                  .filter((t) => t.transactionType === "Credit")
                                  .reduce((sum, t) => sum + t.amount, 0)}
                              />
                            </td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              )}
            </Row>
          </CardBody>
        </Card>
      </LayoutWithBreadCrumb>
    </React.Fragment>
  );
};

export default BankStatement;